module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-4_SK-04f9b292ac93b3757cc5d536f61e85e0.svg";